export interface FontIconOptions {
  fontIcon?: string;
}

export enum SymbolCompletionBehavior {
  ReopenSymbolPicker = 'reopenSymbolPicker',
  ReopenToolList = 'reopenToolList',
  Close = 'close',
}

export interface SymbolOptions {
  symbolPackId: string;
  symbolId: string;
  symbolName?: string;
  completionBehavior?: SymbolCompletionBehavior;
}

export type SymbolToolOptions = SymbolOptions | FontIconOptions;
